import { Card, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaClock, FaUser, FaStar } from 'react-icons/fa';

export default function BlogCard({ post }) {
  const navigate = useNavigate();
  const dateStr = new Date(post.createdAt).toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric',
  });

  return (
    <Card
      className='mb-3 shadow-sm'
      style={{ cursor: 'pointer' }}
      onClick={() => navigate(`/blog/post/${post.slug}`)}
    >
      <Card.Body>
        <div className='d-flex justify-content-between align-items-start'>
          <div>
            {post.isFeatured && (
              <Badge bg='warning' text='dark' className='me-2 mb-2'>
                <FaStar className='me-1' />Featured
              </Badge>
            )}
            <Card.Title>{post.title}</Card.Title>
          </div>
        </div>
        {post.excerpt && (
          <Card.Text className='text-muted'>{post.excerpt}</Card.Text>
        )}
        <div className='d-flex flex-wrap gap-3 text-muted small'>
          <span>
            <FaUser className='me-1' />
            {post.author?.firstName || 'Unknown'}
          </span>
          <span>{dateStr}</span>
          {post.readingTime && (
            <span>
              <FaClock className='me-1' />
              {post.readingTime} min read
            </span>
          )}
        </div>
        {post.tags && post.tags.length > 0 && (
          <div className='mt-2'>
            {post.tags.map((tag) => (
              <Badge key={tag} bg='secondary' className='me-1'>{tag}</Badge>
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}
